__turbopack_context__.v({
  "AnchorDisabled": "Button-module-scss-module__H2hDYq__AnchorDisabled",
  "Button": "Button-module-scss-module__H2hDYq__Button",
  "ButtonDark": "Button-module-scss-module__H2hDYq__ButtonDark",
  "ButtonIcon": "Button-module-scss-module__H2hDYq__ButtonIcon",
  "ButtonLight": "Button-module-scss-module__H2hDYq__ButtonLight",
  "ButtonNone": "Button-module-scss-module__H2hDYq__ButtonNone",
  "ButtonPreIcon": "Button-module-scss-module__H2hDYq__ButtonPreIcon",
  "ButtonText": "Button-module-scss-module__H2hDYq__ButtonText",
  "ButtonTextual": "Button-module-scss-module__H2hDYq__ButtonTextual",
  "ButtonTextualWhite": "Button-module-scss-module__H2hDYq__ButtonTextualWhite",
});
